export enum StorageNamespace {
  detailsPage = 'hg-detail-page',
  searchResults = 'hg-search-results',
  favourites = 'hg-favourites',
  insertionFunnel = 'insertion-funnel',
  searchAlerts = 'hg-search-alerts',
  tenantPlus = 'tenant-plus',
}
